import { Stack, SxProps } from "@mui/material";
import { useContext } from "react";
import Image from "src/components/Image";
import { entitiesUrl } from "src/utils/formatUrl";

import CrossExitBtn from "../../components/CrossExitBtn";
import Context from "../../context";
import CardWrapper from "../CardWrapper";
import Powered from "../Powered";
import BackBtn from "./components/BackBtn";
import ConnectForm from "./ConnectForm";

// ----------------------------------------------------------------------

type Props = {
	sx?: SxProps;
	isSelected?: boolean;
};

export const ConnectAccountPanel = ({ sx, isSelected }: Props) => {
	const { values } = useContext(Context);
	return (
		<CardWrapper sx={sx} isSelected={isSelected}>
			<Stack minWidth={{ xs: 250, sm: 330 }}>
				<BackBtn />
				{values?.showExit && <CrossExitBtn />}
				<Image src={entitiesUrl("renta4")} sx={{ width: 250, mt: 10, alignSelf: "center" }} />
				<ConnectForm />
				<Powered />
			</Stack>
		</CardWrapper>
	);
};

export default ConnectAccountPanel;
